import { apiWithBody } from '@nu-art/thunderstorm-frontend/index';
import { Module } from '@nu-art/ts-common';
import { ApiDef_FHIR } from '@app/fhir-shared';
export class ModuleFE_FHIR_Class extends Module {
    vv1;
    constructor() {
        super();
        this.vv1 = {
            fetchFhir: apiWithBody(ApiDef_FHIR.vv1.fetchFhir)
        };
    }
    init() {
    }
}
export const ModuleFE_FHIR = new ModuleFE_FHIR_Class();
//# sourceMappingURL=ModuleFE_FHIR.js.map